import React from 'react';
import styles from './ErrorBoundary.module.scss';
import {
  BaseText,
  EBaseTextWeight,
  EBaseTextSize,
  EBaseTextPosition,
} from '@spinwise/react-component-library/BaseText';
import { ButtonLibrary } from 'Libraries/buttons.library';
import { EBrandTextColor } from 'Libraries/typography.library';
import { withTranslation } from 'react-i18next';
import { EComponentVisibility } from '@spinwise/react-component-library/Global';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import {
  EBaseButtonSize,
  EBaseButtonTypeAttribute,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';

class ErrorBoundary extends React.Component<any, any> {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    this.setState({ hasError: true, error: error.message });
  }

  render() {
    const { t } = this.props;
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <main className={styles.error_container}>
            <div className="container-app">
              <div className="page-404">
                <div className="page-404-text-container d-fl fl-d-c jc-c ai-c">
                  <div className={`${EComponentVisibility.DesktopOnly}`}>
                    <div className="w-100 d-fl jc-c  page-404-image-container">
                      <img loading="lazy" src={'/images/background-error.jpg'} alt="" />
                    </div>
                  </div>

                  <div className={`${EComponentVisibility.MobileTablet}`}>
                    <div className="w-100 d-fl jc-c  page-404-image-container">
                      <img loading="lazy" src={'/images/background-error-small.jpg'} alt="" />
                    </div>
                  </div>

                  <div className={`${EComponentVisibility.DesktopOnly}`}>
                    <BaseText
                      value={t('error.page.title')}
                      weight={EBaseTextWeight.W600}
                      size={EBaseTextSize.Title2}
                      color={EBrandTextColor.PurpleDark}
                      alignment={EBaseTextPosition.Center}
                    ></BaseText>
                  </div>
                  <div className={`${EComponentVisibility.MobileTablet}`}>
                    <BaseText
                      value={t('error.page.title')}
                      weight={EBaseTextWeight.W600}
                      size={EBaseTextSize.Title4}
                      color={EBrandTextColor.PurpleDark}
                      alignment={EBaseTextPosition.Center}
                    ></BaseText>
                  </div>
                  <BaseText
                    value={t('error.page.subtitle')}
                    size={EBaseTextSize.Regular}
                    color={EBrandTextColor.Black06}
                    alignment={EBaseTextPosition.Center}
                  ></BaseText>
                  <BaseText
                    value={this.state.error}
                    size={EBaseTextSize.Regular}
                    color={EBrandTextColor.Black06}
                    alignment={EBaseTextPosition.Center}
                  ></BaseText>

                  <div
                    className="d-fl jc-c ai-c fl-d-r page-404-text-container-button-box"
                    onClick={() => {
                      window.location.href = '/';
                    }}
                  >
                    <ButtonTextOnly
                      label={t('return.home.btn.label')}
                      size={EBaseButtonSize.Large}
                      type={ButtonLibrary.CTA}
                      borderRadius={EButtonBorderRadiusStrength.Seven}
                      typeAttribute={EBaseButtonTypeAttribute.Submit}
                      fullWidth={false}
                      alignText={EButtonTextAlign.Center}
                    />
                  </div>
                  <ButtonTextOnly
                    label={t('contact.us.btn.label')}
                    type={ButtonLibrary.AccountNavActive}
                    size={EBaseButtonSize.Large}
                    onClick={() => {
                      window.location.href = '/';
                    }}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      );
    }

    // Return children components in case of no error

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
